module.exports = __webpack_public_path__ + "img/qufu-name-3.7b56109e.png";